export default __webpack_public_path__ + "static/media/01.2a4318fc.jpg";